module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Regular.4e29102.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Regular.woff2
// module id = /Gz/
// module chunks = 0